import {Pipe, PipeTransform} from '@angular/core';
import {LayoutPreset, LayoutPresetCategory} from './layout-preset';

@Pipe({
    name: 'layoutPresetFilterPipe',
    pure: false,
    standalone: false
})
export class LayoutPresetFilterPipe implements PipeTransform {
    public transform(layoutPresets: LayoutPreset[], layoutPresetCategory: LayoutPresetCategory): any {
        if (!layoutPresets || !layoutPresetCategory) {
            return layoutPresets;
        }

        return layoutPresets.filter(item => item.category === layoutPresetCategory);
    }
}
